import dynamic from 'next/dynamic';
import React, { useEffect } from 'react';
import type { BrowseCategorySlug } from '@engage/browse-categories';
import { useMembersRouter as useRouter } from '@members/localization/useMembersRouter';
import { useIsFreemiumMember } from '@members/tiering/hooks/useIsFreemiumMember';

const LibraryPage = dynamic(() => import('@members/pg-library/LibraryPage'), {
  ssr: false,
});

export default function ClassesPage() {
  const router = useRouter();
  const isFreemiumMember = useIsFreemiumMember();
  const categorySlug = router.query?.categorySlug?.[0];
  const categorySlugRoute = categorySlug ?? (isFreemiumMember ? 'free' : 'all');

  useEffect(() => {
    if (!categorySlug) {
      router.replace(`/classes/${categorySlugRoute}`);
    }
  }, [categorySlugRoute]);

  return <LibraryPage categorySlug={categorySlugRoute as BrowseCategorySlug} />;
}
